import getToken from "@/utils/getToken";
import getUserInfo from "@/utils/getUserInfo";
import { mapMutations, mapState } from "vuex";
import InvoiceHelp from "@/views/issueInvoice/invoiceHelp.vue";
import { getUrlParameter } from "@/utils/utils.js";
export default {
  components: {
    InvoiceHelp,
  },
  data() {
    return {
      buyerType: "个人", //抬头类型
      buyerName: "个人", //发票抬头
      buyerTaxNo: "", //纳税人识别号
      invoiceItem: "", //发票项目
      invoiceItemCode: "",
      amount: "", // 发票金额
      buyerEmail: "", //邮箱信息
      amountMax: "", //最大可开票金额
      invoiceItems: [
        //发票项目列表信息
      ],
      buyerTypeOption: {
        personage: true, //个人是否支持
        enterprise: true, //企业是否支持
      },
      showBuyerTypePop: false,
      columns: [{ text: "个人" }],
      buyerNameDanger: false,
      buyerTaxNoDanger: false,
      buyerAmountDanger: false,
      buyerEmailDanger: false,
      isSubmit: false,
      login: 2,
      dangerAgreement: false,
      enterpriseAgreement: false,
      showDangerAgreement: false,
      dangerInfoList: [
        "根据《中华人民共和国发票管理办法》第二十二条、三十七条规定，发票应如实开具，任何单位和个人不得让他人为自己开具与实际经营业务情况不符的发票。",
        "违反办法规定虚开发票的，由税务机关没收违法所得；虚开金额在1万元以下的，可以并处5万元以下的罚款；虚开金额超过1万元的，并处5万元以上50万元以下的罚款；构成犯罪的，依法追究刑事责任。",
        "请您务必根据服务购买方真实情况，如实填写购买方相关信息，否则将承担相应法律责任。",
      ],
      showEnterpriseAgreement: false,
      enterpriseAagreementPromise: false,
      enterpriseAgreementInfoList: [
        "我服务中心与学员/监护人、任职单位就开具单位抬头增值税普通发票达成以下协议：",
        "1、任职单位确认已知晓并理解学而思1对1报名时的全部须知（包括持卡须知、家长须知、学员须知）并同意承担须知下的所有培训费，培训费由监护人先行支付。",
        "2、服务中心尚未向学员开具个人抬头发票的情形下，将向监护人任职单位开具抬头为任职单位的合法正规增值税普通发票。",
        "3、发票号码由服务中心开具完毕后填写，此协议一式一份，开票单位留存。",
        "4、根据国税局下发2017年16号文件《关于增值税发票开具有关问题公告》自2017.7.1开具增值税普通发票需填写购买方纳税人识别号或统一社会信用代码。",
        "5、开具对公发票时将监护人手机号在发票的“备注”一栏中。",
      ],
      guardian: "",
      guardianRelation: "",
      guardianPhone: "",
      rolesList: [],
      modelFormSaveData: {
        guardian: "",
        guardianRelation: "",
        guardianPhone: "",
        enterpriseAagreementPromise: false,
      },
      showInvoiceApply: false,
      buyerPhone: "",
      drawer: "",
      loading: false,
      showInvoiceItemPop: false,
    };
  },
  created() {
    this.isSubmit = false;
    this.loading = true;
    this.changeLoading(true);
    // login 1未登陆  2已登陆
    getToken().then(async (token) => {
      let userinfo = await getUserInfo();
      this.buyerPhone = userinfo.phone;
      this.drawer = userinfo.realName;
      console.log(token, userinfo, "8989");
      if (token) {
        this.login = 2;
      } else {
        this.login = 1;
        console.log("no login",this.login)
        window.dhsdk.startLogin();
      }
    });
  },
  computed: {
    ...mapState("invoiceApply", ["showInvoiceHelp"]),
  },
  async mounted() {
    console.log(this.showInvoiceApply, "8989");
    window.dhsdk.titleChanged({
      title: "开具电子发票",
    });
    let cityCode = getUrlParameter("city_code");
    this.handleCityCode(cityCode);
    this.$api.invoice
      .invoiceBasicInfo()
      .then((res) => {
        this.loading = false;
        this.changeLoading(false);
        if (res.errcode == 0) {
          console.log("配置城市信息" + res.data.cityCodes);
          let personage = res.data.buyerTypeOption.personage;
          let enterprise = res.data.buyerTypeOption.enterprise;
          if (personage && enterprise) {
            //个人企业均配置
            this.buyerType = "个人";
          } else if (personage) {
            this.buyerType = "个人";
          } else if (enterprise) {
            this.buyerType = "企业单位";
          }
          this.cityCodes = res.data.cityCodes;
          this.amountMax = res.data.allowOpenInvoiceAmount;
          let items = res.data.items;
          this.invoiceItem = res.data.items[0].invoiceItem;
          this.invoiceItemCode = res.data.items[0].invoiceItemCode;
          this.buyerTypeOption = res.data.buyerTypeOption;
          //处理发票项目
          items.forEach((item) => {
            this.invoiceItems.push(item.invoiceItem);
          });
          //最近开过票，用来进行数据的回填
          //0无 1个人  2企业
          if (res.data.buyerType) {
            this.buyerEmail = res.data.buyerEmail;
            this.buyerName = res.data.buyerName;
            this.buyerTaxNo = "" || res.data.buyerTaxNo;
            this.buyerType = res.data.buyerType == 2 ? "企业单位" : "个人";
            this.$refs.buyerName.value = this.buyerName || "";
            this.$refs.buyerEmail.value = this.buyerEmail || "";
            if (this.refs.buyerTaxNo) {
              this.refs.buyerTaxNo.value = this.buyerTaxNo || "";
            }
          }
        } else {
          this.$toast(res.msg);
        }
        console.log(this.buyerEmail, "8787");
      })
      .catch(() => {
        this.loading = false;
        this.changeLoading(false);
        // this.$toast(err);
      });
    this.$api.invoice.invoiceQueryRoleItem().then((res) => {
      this.rolesList = res.data.roles;
    });
  },
  methods: {
    ...mapMutations({
      changeLoading: "changeLoading",
    }),
    ...mapMutations("invoiceApply", [
      "handleShowInvoiceHelp",
      "handleCityCode",
    ]),
    handleBuryTypeSelect(value) {
      this.showBuyerTypePop = value;
    },
    handleBuryTypeConfirm(value) {
      this.showBuyerTypePop = false;
      this.buyerType = value.text;
      this.handleEmptyVerify();
      if (this.buyerType == "企业单位" && !this.dangerAgreement) {
        this.showDangerAgreement = true;
      }
    },

    handleInvoiceItemSelect(value) {
      this.showInvoiceItemPop = value;
    },
    handleInvoiceItemConfirm(value) {
      console.log(value, "8778");
      this.showInvoiceItemPop = false;
      this.invoiceItem = value;
    },
    //开具单位抬头协议
    handleEnterpriseAagree(value, type) {
      switch (type) {
        case "show":
          this.showEnterpriseAgreement = value;
          break;
        case "agree":
          if (!this.enterAgreeSubmitValidator()) return;
          this.showEnterpriseAgreement = value;
          this.enterpriseAgreement = true;
          this.handleEmptyVerify();
          break;
        case "disAgree":
          this.enterpriseAgreement
            ? (this.enterpriseAgreement = false)
            : (this.showEnterpriseAgreement = true);
          this.handleEmptyVerify();
          break;
        default:
          break;
      }
    },
    //风险预警
    handleDangerAgreement(value, type) {
      switch (type) {
        case "show":
          this.showDangerAgreement = value;
          break;
        case "agree":
          this.showDangerAgreement = value;
          this.dangerAgreement = true;
          this.handleEmptyVerify();
          if (!this.enterpriseAgreement) {
            this.showEnterpriseAgreement = true;
          }
          break;
        case "disAgree":
          this.dangerAgreement
            ? (this.dangerAgreement = false)
            : (this.showDangerAgreement = true);
          this.handleEmptyVerify();
          break;
        default:
          break;
      }
    },
    handleGuardian(id, type) {
      if (type == "relation") {
        this.guardianRelation = id;
      } else if (type == "promise") {
        this.enterpriseAagreementPromise = !this.enterpriseAagreementPromise;
      }
    },

    //验证开具单位抬头协议
    enterAgreeSubmitValidator() {
      let regphone =
        /^(((13[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[3-8]{1})|(18[0-9]{1})|(19[0-9]{1})|(14[5-7]{1}))+\d{8})$/;
      let guardian = "";
      let guardianRelation = "";
      let guardianPhone = "";
      let enterpriseAagreementPromise = "";

      guardian = this.guardian;
      guardianRelation = this.guardianRelation;
      guardianPhone = this.guardianPhone;
      enterpriseAagreementPromise = this.enterpriseAagreementPromise;

      if (guardian.trim().length == 0) {
        this.$toast("请填写监护人姓名");
        return false;
      } else if (guardian.trim().length > 20) {
        this.$toast("监护人姓名最多支持20个字符");
        return false;
      } else if (!/^[\u4e00-\u9fa5\sa-zA-Z]{1,20}$/.test(guardian.trim())) {
        this.$toast("监护人姓名支持汉字或字母大小写或空格");
        return false;
      } else if (guardianRelation.toString().trim().length == 0) {
        this.$toast("请选择与学员关系");
        return false;
      } else if (guardianPhone.trim().length == 0) {
        this.$toast("请填写手机号码");
        return false;
      } else if (!regphone.test(guardianPhone.trim())) {
        this.$toast("手机号码填写错误");
        return false;
      } else if (!enterpriseAagreementPromise) {
        this.$toast("请勾选承诺");
        return false;
      }
      this.modelFormSaveData.guardian = this.guardian;
      this.modelFormSaveData.guardianRelation = this.guardianRelation;
      this.modelFormSaveData.guardianPhone = this.guardianPhone;
      this.modelFormSaveData.enterpriseAagreementPromise =
        this.enterpriseAagreementPromise;
      return true;
    },
    // 发票抬头校验  限制输入中文
    handleBuyerName(e) {
      this.buyerName = e.target.value;
      let value = this.buyerName.trim();
      let regex =  /^([\u4e00-\u9fa5]|[（）]|[$]|[%]|[=]){0,200}$/
      if (regex.test(value)) {
        this.buyerNameDanger = false;
      } else {
        this.buyerNameDanger = value === "" ? false : true;
      }
      console.log(this.buyerNameDanger, "7777");
      this.handleEmptyVerify();
    },
    //纳税识别号
    handleBuyerTaxNo(e) {
      this.buyerTaxNo = e.target.value;
      console.log(this.buyerTaxNo, "8989");
      let value = this.buyerTaxNo.trim();
      let regex = /^[0-9a-zA-Z]{7,20}$/;
      if (regex.test(value)) {
        this.buyerTaxNoDanger = false;
      } else {
        this.buyerTaxNoDanger = value === "" ? false : true;
      }
      this.handleEmptyVerify();
    },
    handleAmountVerify() {
      let currenAmount = Math.round(Number(this.amount) * 100) / 100;
      if (
        Number(currenAmount) > Number(this.amountMax) ||
        !Number(currenAmount)
      ) {
        return false;
      }
      return true;
    },
    //开票金额  限制数字
    handleAmount(e) {
      this.amount = e.target.value;
      let value = this.amount;
      let regx = /^\d+$|^\d*\.\d+$/;
      if (!regx.test(this.amount)) {
        this.buyerAmountDanger = value === "" ? false : true;
      } else if (!this.handleAmountVerify()) {
        this.buyerAmountDanger = true;
      } else {
        this.buyerAmountDanger = false;
      }
      this.handleEmptyVerify();
      console.log(this.amount, regx.test(this.amount), "8989");
    },
    handleAmountBits(e) {
      let value = e.target.value;
      if (this.amount === "") return;
      this.amount = this.handleMoney(value);
      console.log(this.amount, "8989");
    },
    //邮箱
    handleBuyerEmail(e) {
      this.buyerEmail = e.target.value;
      let value = this.buyerEmail.trim();
      let regx =
        /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
      if (regx.test(value)) {
        this.buyerEmailDanger = false;
      } else {
        this.buyerEmailDanger = value === "" ? false : true;
      }
      this.handleEmptyVerify();
    },
    //清除已选值
    handleClear(type) {
      switch (type) {
        case "amount":
          this.amount = "";
          break;
        case "email":
          this.buyerEmail = "";
          break;
        case "buyerName":
          this.buyerName = "";
          break;
        case "buyerTaxNo":
          this.buyerTaxNo = "";
          break;
        default:
          break;
      }
      this.handleEmptyVerify();
    },
    //是否含有空值
    handleEmptyVerify() {
      let params = {
        buyer: this.buyerType, //抬头类型
        buyerName: this.buyerName, //发票抬头
        buyerTaxNo: this.buyerTaxNo, //纳税人识别号
        invoiceItem: this.invoiceItem || "*非学历教育服务*培训费", //发票项目
        amount: this.amount, // 发票金额
        buyerEmail: this.buyerEmail, //邮箱信息
      };
      if (this.buyerType == "个人") {
        delete params.buyerTaxNo;
      }

      let isIncludeEmpty;
      // 判断是否有值为空
      for (let item in params) {
        if (!params[item]) {
          isIncludeEmpty = false;
          break;
        } else {
          isIncludeEmpty = true;
        }
      }
      if (this.buyerType === "个人") {
        if (
          !this.buyerNameDanger &&
          !this.buyerAmountDanger &&
          !this.buyerEmailDanger &&
          isIncludeEmpty
        ) {
          this.isSubmit = true;
        } else {
          this.isSubmit = false;
        }
      } else if (this.buyerType === "企业单位") {
        if (
          !this.buyerNameDanger &&
          !this.buyerTaxNoDanger &&
          !this.buyerAmountDanger &&
          !this.buyerEmailDanger &&
          isIncludeEmpty &&
          this.enterpriseAgreement &&
          this.dangerAgreement
        ) {
          this.isSubmit = true;
        } else {
          this.isSubmit = false;
        }
      }
    },
    //判断是否和要求
    handleLogicVerify() {
      let params = {
        buyer: this.buyerType, //抬头类型
        buyerName: this.buyerName, //发票抬头
        buyerTaxNo: this.buyerTaxNo, //纳税人识别号
        invoiceItem: this.invoiceItem || "*非学历教育服务*培训费", //发票项目
        amount: this.amount, // 发票金额
        buyerEmail: this.buyerEmail, //邮箱信息
      };
      if (this.buyerType == "个人") {
        delete params.buyerTaxNo;
      }
      console.log(this.buyerNameDanger, this.buyerAmountDanger, "8888");
      // let buyerTaxValidator =
      //   this.buyerTaxNoDanger && this.buyerType == "企业单位";
      // 判断是否有值为空
      if (this.buyerNameDanger || !this.buyerName) {
        this.$toast("请填写正确的发票抬头");
        return false;
      } else if (
        (this.buyerTaxNoDanger && this.buyerType == "企业单位") ||
        (!this.buyerTaxNo && this.buyerType == "企业单位")
      ) {
        this.$toast("请填写正确的纳税人识别号");
        return false;
      } else if (this.buyerAmountDanger || !this.amount) {
        if (this.amount > 0) {
          this.$toast("您的可开票金额最大为" + this.amountMax);
        } else {
          this.$toast("请填写正确开票金额");
        }
        return false;
      } else if (this.buyerEmailDanger || !this.buyerEmail) {
        this.$toast("请填写正确的邮箱");
        return false;
      } else if (!this.dangerAgreement && this.buyerType == "企业单位") {
        this.$toast("请勾选《风险预警须知》");
        return false;
      } else if (!this.enterpriseAgreement && this.buyerType == "企业单位") {
        this.$toast("请勾选《开具单位抬头协议》");
        return false;
      } else {
        return true;
      }
    },
    handleMoney(value, num) {
      num = num > 0 && num <= 20 ? num : 2;
      value =
        parseFloat((value + "").replace(/[^\d.-]/g, "")).toFixed(num) + ""; //将金额转成比如 123.45的字符串
      var valueArr = value.split(".")[0].split(""); //将字符串的数变成数组
      const valueFloat = value.split(".")[1]; // 取到 小数点后的值
      let valueString = "";
      for (let i = 0; i < valueArr.length; i++) {
        valueString += valueArr[i]; //循环 取数值并在每三位加个','
      }
      const money = valueString.split("").join("") + "." + valueFloat; //拼接上小数位
      return money;
    },
    handleSubmitForm() {
      let params = {
        amount: 0,
        buyer_type: "",
        buyer_name: "",
        buyer_tax_no: "",
        invoice_item_code: "",
        invoice_item: "",
        buyer_email: "",
        drawer: "",
        invoice_type: 1,
        buyer_phone: "",
      };
      params.amount = this.amount * 100;
      params.buyer_type = this.buyerType == "个人" ? "1" : "2";
      params.buyer_name = this.buyerName;
      params.buyer_tax_no = this.buyerTaxNo;
      params.invoice_item_code = this.invoiceItemCode;
      params.invoice_item = this.invoiceItem;
      params.buyer_email = this.buyerEmail;
      params.buyer_phone = this.buyerPhone;
      params.drawer = this.drawer;
      if (this.buyerType == "个人") {
        delete params.buyer_tax_no;
      }
      if (this.buyerType == "企业单位") {
        params.guardian = this.modelFormSaveData.guardian;
        params.guardian_phone = this.modelFormSaveData.guardianPhone;
        params.guardian_relation = Number(
          this.modelFormSaveData.guardianRelation
        );
      }
      this.changeLoading(true);
      this.$api.invoice
        .invoiceApply(params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.changeLoading(false);
          if (res.error_code == 0) {
            this.showInvoiceApply = false;
            window.location.href =
              "#/invoice/success" + "?amount=" + params.amount / 100;
          } else {
            this.$toast(res.message);
          }
        })
        .catch(() => {
          this.changeLoading(false);
        });
    },
    handleInvoiceApply() {
      this.handleLogicVerify();
      if (!this.isSubmit) return;
      this.showInvoiceApply = true;
    },
    handleVerifyInvoice() {
      this.showInvoiceApply = false;
    },
    handleGoHistory() {
      this.$router.push({ name: "invoiceHistory" });
    },
    handleShowHelp() {
      this.handleShowInvoiceHelp(true);
      console.log(this.showInvoiceHelp, "8989");
    },
  },
};
